const { connect } = require('react-redux');
const { context } = require('../app-context');
const { push: Push } = require('connected-react-router');
const AppLayout = require('../layouts/AppLayout');

const actions   = context.actions;
const selectors = context.selectors.all;

module.exports = connect(
    (state) => ({
        currentUser: selectors.getCurrentUser(state)?.user() || null,
        rootSchool: selectors.getRootSchool(state),
        canJoinNearpeerCommunity: selectors.getCanJoinNearpeerCommunity(state),
        switchableCommunities: selectors.getSwitchableCommunities(state),
        joinableCommunities: selectors.getJoinableCommunities(state),
        currentSchool: selectors.getCurrentSchool(state),
        numUnreadNotifications: selectors.getUnreadNotificationsCount(state),
        unreadOffersCount: selectors.getUnreadOffersCount(state),
        hasOffers: selectors.getHasOffers(state),
        isLoadingOffers: selectors.getIsLoadingOffers(state),
        unreadResourcesCount: selectors.getUnreadResourcesCount(state),
        hasResources: selectors.getHasResources(state),
        isLoadingResources: selectors.getIsLoadingResources(state),
        schoolSlug: selectors.getCurrentSchoolSlug(state),
        appHeaderLogoUrl: selectors.getAppHeaderLogoBase(state),
        hasResourcesPage: selectors.getCurrentSchoolHasResources(state),
        resourcesUrl: selectors.getCurrentSchoolResourcesUrl(state),
        isOffline: selectors.getIsOffline(state),
        notificationsOpen: selectors.getNotificationsOpen(state),
        otherCommunityUnreadCounts: selectors.getOtherCommunityUnreadCounts(state),
        logoutDialogOpen: selectors.getLogoutDialogOpen(state),
        modalOpen: selectors.getModalIsOpen(state),
        rolePermissions: selectors.getCurrentUserRolePermissions(state),
        role: selectors.getCurrentUserRole(state),
        rootLoading: selectors.getMainAppLoading(state),
        path: window.location.pathname,
        isSSOSchool: selectors.getIsSSOSchool(state),
        isCommunity: selectors.getSchoolIsCommunity(state),
        isReviewEnabled: selectors.getSchoolIsReviewEnabled(state),
        nearpeerSchool: selectors.getSchoolById(state, 1),
        debug: selectors.getDebug(state)
    }), {
        onLogout: actions.auth.logout,
        openNotifications: actions.app.openNotifications,
        closeNotifications: actions.app.closeNotifications,
        openLogoutDialog: actions.app.openLogoutDialog,
        closeLogoutDialog: actions.app.closeLogoutDialog,
        navigate: Push,
        setDebug: (payload) => (dispatch) => { // eslint-disable-line

            return dispatch(actions.app.setDebug({ debug: payload }));
        }
    }
)(AppLayout);